export const NLPEnvOptions = ['local', 'dev', 'staging', 'prod'];
//# sourceMappingURL=consts.js.map